import { Box, Flex, Select } from '@chakra-ui/react';
// import { render } from 'datocms-structured-text-to-html-string';
import { filter } from 'lodash';
import { nanoid } from 'nanoid';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/Headings/SectionTitle';
import SingleLineText from '@components/UI/SingleLineText';
import StructuredTextContent from '@components/UI/StructuredTextContent';
// import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import config from '@config';
import CountriesList from '@constants/CountriesList-MoM';

/**
 *
 */
const PrivacyTcBlock = ({ sectionContent, region, lang }) => {
  const [curRegion, setCurRegion] = useState('');
  const [content, setContent] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [selectCountry, setSelectedCountry] = useState('');
  const [selectedLang, setSelectedLang] = useState('en');
  const router = useRouter();
  const [error, setError] = useState(null);
  const path = router.asPath;
  const singleDrpText = sectionContent.find(el => el.fieldId === 'cntry-drp');
  const singleLngText = sectionContent.find(el => el.fieldId === 'lng-drp');
  const lngList = sectionContent.find(
    el => el._modelApiKey === 'json_table'
  )?.data;
  const countries = CountriesList;
  // const lngList = config.lngList;

  useEffect(() => {
    const termsOrPri = path.indexOf('terms') > -1 ? 'terms' : 'privacy';
    setContent(undefined);
    if (curRegion && selectedLang) {
      let url = `${
        config.CLOUDFRONT_VIDEO_BUCKET_URL
      }/mom/${termsOrPri}/${curRegion}_${selectedLang || 'en'}.json`;
      // console.log(url, 'url');
      setLoading(true);
      fetch(url)
        .then(response => response.json())
        .then(data => {
          setContent(data);
        })
        .catch(error => {
          url = `${config.CLOUDFRONT_VIDEO_BUCKET_URL}/mom/${termsOrPri}/${curRegion}_en.json`;
          fetch(url)
            .then(response => response.json())
            .then(data => {
              // console.log('data', data);
              setContent(data);
            })
            .catch(error => {
              // console.log(error, 'error22');
              setError(error);
            });
          setError(error);
        });
      setLoading(false);
    }
  }, [curRegion, selectedLang]);

  return (
    <Box w="100%" px="1rem">
      <Box maxW={915} mx="auto" width="100%">
        <SectionTitle
          titleObj={sectionContent[0]}
          fontFamily="'FedraSansStd-medium', sans-serif"
        />
        <Flex
          gridGap="2rem"
          flexWrap="wrap"
          flexDir={{ base: 'column', md: 'row' }}
          mt="50px"
        >
          <Box
            flex={1}
            maxW={{ base: '100%', md: '50%' }}
            w={{ base: '100%', md: '50%' }}
          >
            <SingleLineText
              sectionContent={singleDrpText}
              fontFamily="'FedraSansStd-book', sans-serif"
              my={{ base: '4px' }}
            />
            <Select
              key="country"
              id="country"
              width="100%"
              isRequired={true}
              placeholder="Country"
              fontFamily="'FedraSansStd-book', sans-serif"
              fontSize="18px"
              color="#8a8173"
              height={{ base: '50px', lg: '40px' }}
              borderRadius="3px"
              border="1px solid #a1a1a1"
              value={selectCountry}
              //   backgroundColor={inputBackground}
              // onChange={props.handleChange}
              onChange={event => {
                // props.handleChange(event);
                const selected = event.target.value;
                setSelectedLang('en');
                setSelectedCountry(selected);
                const countryObj = filter(CountriesList, function (country) {
                  // console.log('country', country.region, `${region}/${language}`, country.region === `${region}/${language}`);
                  return country?.value?.toUpperCase() === selected;
                })[0];
                setCurRegion(countryObj?.reg);
              }}
            >
              {countries.map(country => {
                return (
                  <option key={nanoid()} value={country.value}>
                    {country.name}
                  </option>
                );
              })}
            </Select>
          </Box>
          {selectCountry && (
            <Box
              flex={1}
              maxW={{ base: '100%', md: '50%' }}
              w={{ base: '100%', md: '50%' }}
            >
              <SingleLineText
                sectionContent={singleLngText}
                fontFamily="'FedraSansStd-book', sans-serif"
                my={{ base: '4px' }}
              />
              <Select
                key="language"
                id="language"
                width="100%"
                isRequired={true}
                //placeholder={'Language'}
                defaultValue="English"
                fontFamily="'FedraSansStd-book', sans-serif"
                fontSize="18px"
                color="#8a8173"
                height={{ base: '50px', lg: '40px' }}
                borderRadius="3px"
                border="1px solid #a1a1a1"
                value={selectedLang}
                onChange={e => setSelectedLang(e.target.value)}
                //   backgroundColor={inputBackground}
                //   disabled={!props.values.country ? true : false}
              >
                {lngList?.map(lang => {
                  return (
                    <option key={nanoid()} value={lang.val}>
                      {lang.name}
                    </option>
                  );
                })}
              </Select>
            </Box>
          )}

          <Box flex="100%" w="100%" mb={{ base: '4rem', md: '5rem' }}>
            {content && !loading && (
              <>
                {content && (
                  <Box className="event-text">
                    {StructuredTextContent(content?.content?.content)}
                    {/* <StructuredTextParser
                      mx="0"
                      str={render(
                        content?.content?.content?.value.document || ''
                      )}
                      region={region}
                      lang={lang}
                      fontFamily="FedraSansStd-book"
                      className="event-text"
                      lineHeight={{ base: '27px', md: '29px' }}
                      sx={{
                        h1: {
                          fontFamily: 'FedraSerifAStdBook',
                          fontSize: { base: '20px', md: '28px' },
                        },
                        ul: {
                          pl: '1rem',
                        },
                        ol: {
                          pl: '1rem',
                        },
                      }}
                    /> */}
                  </Box>
                )}
              </>
            )}
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};

export default PrivacyTcBlock;
